import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';



const Mainpage = () => {
  return (
    <>

      <div className="flex flex-col min-h-screen">
      
      <NavBar/> 
           
      <h1 className="pt-24">Information Technology Manager with more than 7 years of experience in the IT Field delivering
        technical advisory and support to the reputed hotel chain ‘IHG Hotels & Resorts’. Proven success in
        managing high-end network devices, servers, and workstations. Innovative professional with strong
        passion and expertise in Information Technology.<br/>Part-time Python and React developer passionate about crafting innovative solutions.</h1>    


      <Footer/> 

      </div>
       
    </>
  )
}

export default Mainpage
